import React, { useState, useEffect } from 'react'
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import { SlDrawer, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { useFormik } from "formik";
import api from "../../services/api";
import { formatDateWithTime } from '../../utils/dateFormat';
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { useSelector } from 'react-redux';
import { ScrollContainer } from 'react-indiana-drag-scroll';
import { debounce } from '../../utils/Debounce';
import { SlTooltip, SlIconButton, SlButton } from '@shoelace-style/shoelace/dist/react';
import { langoptions } from '../../utils/constants';


const initialEditions = {
    language: '',
    edition_name: ''
}
let initialValues = JSON.parse(JSON.stringify(initialEditions));


const EditionSchema = Yup.object().shape({
    language: Yup.string().required('Language is required'),
    edition_name: Yup.string().required('Edition is required'),

})


function Editions() {

    const navigate = useNavigate()

    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [flag, setFlag] = useState('')
    const [id, setId] = useState('');
    const [search, setSearch] = useState("")

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        loadData(search, event.selected);
    };
    const HeaderSearch = useSelector(state => state.Head.adssearch)

    const handleClose = () => {
        setShow(false);
        setSubmit(false);
        initialValues = JSON.parse(JSON.stringify(initialEditions));
        formik.setValues(initialValues);
    }

    const handleShow = (choose, item) => {
        if (choose === "add") {
            formik.setValues(item);
            setShow(true);
        }
        if (choose === 'edit') {
            initialValues.language = item.language
            initialValues.edition_name = item.edition_name
            formik.setValues(initialValues);
            setShow(true)
        }
    };

    useEffect(() => {
        Header()
    }, [HeaderSearch])

    const loadData = async (searchString = '', page = 0) => {
        try {
            setLoader(true);
            let res = await api({
                url: `/birdview/getEditions`,
                method: "POST",
                responseType: "json",
                data: {
                    page,
                    limit: config.PER_PAGE,
                    search: searchString
                }
            });
            setData(res.data.data.length ? res.data.data : [])
            setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
            setLoader(false);
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const Header = () => {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        loadData(HeaderSearch, 0);
    }

    const searchData = e => {
        setSearch(e.target.value);
        setCurrentPage(0);
        loadData(e.target.value, 0);
    }
    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }

    let formik = useFormik({
        initialValues: JSON.parse(JSON.stringify(initialEditions)),
        validationSchema: EditionSchema,
        onSubmit: async (values) => {
            if (flag === 'add') {
                try {
                    let res = await api({
                        url: `/birdview/addEdition`,
                        method: "POST",
                        responseType: "json",
                        data: values
                    });
                    if (res?.data?.code === 500) {
                        Toast('error', res.data.message);
                    } else {
                        Toast("success", "Edition Added Successfully");
                        handleClose();
                        setCurrentPage(0);
                        setSearch('');
                        loadData(search, 0);
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
            if (flag === 'edit') {
                try {
                    let res = await api({
                        url: `/birdview/editEdition/${id}`,
                        method: "PUT",
                        responseType: "json",
                        data: values
                    });
                    if (res?.data?.code === 500) {
                        Toast('error', res.data.message);
                    } else {
                        Toast("success", "Edition updated Successfully");
                        handleClose()
                        loadData(search, currentPage);
                        values.edition_name = ''
                        values.language = ''


                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
        }
    });
    const getLanguageNameByCode = (language) => {
        const lang = langoptions.find(option => option.value === language);
        return lang ? lang.label : 'Unknown';
    };

    return (
        <>

            <div className='flex gap-4 justify-end mb-4'>
                <SlInput size="small" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Name / Email / Mobile.." >
                    <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                </SlInput>
                <SlButton size="small" variant="primary" onClick={() => { handleShow("add", {}); setFlag('add') }}>Add Edition</SlButton>
            </div>
            <SlDrawer label="Add Edition" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} >
                <form onSubmit={formik.handleSubmit}>
                    {/* Language */}
                    <div className="mb-3">
                        <label className="mb-1">Language</label><span className="text-red-600">*</span>
                        <select
                            className="form-select"
                            aria-label="Select Language"
                            name="language"
                            onBlur={formik.handleBlur}
                            value={`${formik.values.language}`}
                            onChange={(e) => {
                                formik.setFieldValue("language", e.target.value);
                            }}
                        >
                            <option value="">Select Language</option>
                            {langoptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                        {submit && formik.errors.language ? (
                            <div className="text-red-600">{formik.errors.language}</div>
                        ) : null}
                    </div>

                    {/* Edition Name */}
                    <div className="mb-3">
                        <label className="mb-1"> Edition Name</label><span className="text-red-600">*</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Edition Name"
                            aria-label=""
                            name="edition_name"
                            value={formik.values.edition_name}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.edition_name ? (
                            <div className="text-red-600	">{formik.errors.edition_name}</div>
                        ) : null}
                    </div>


                    <div slot="footer">
                        <SlButton
                            type="submit"
                            variant="primary"
                            size="small"
                            onClick={(e) => setSubmit(true)}>Submit</SlButton>
                    </div>

                </form>
            </SlDrawer>

            < div className=' mb-4' >
                <ScrollContainer>
                    <table className='table table-bordered'>
                        <thead className="sticky top-0 ">
                            <tr>
                                <th >Language</th>
                                <th >Edition Name</th>
                                <th>Created Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        {(data?.length && !loader) ? (
                            <tbody>
                                {data.map((item, index) => {
                                    return (
                                        <tr key={item.edition_id} className="group/details hover:bg-slate-100">
                                            <th scope='row' >{getLanguageNameByCode(parseInt(item.language))}</th>
                                            <td >{item.edition_name}</td>
                                            <td >{formatDateWithTime(item.created_on)}</td>
                                            <td >
                                                <div className='inline-flex gap-3'>
                                                    <SlTooltip content="Edit Edition">
                                                        <SlIconButton
                                                            library="lucide"
                                                            name="edit"
                                                            onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.edition_id) }}></SlIconButton>
                                                    </SlTooltip>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>) : ((!data?.length && !loader)
                                ? <NoDataFound colspan="8" />
                                : <TableLoader colspan="8" />
                        )
                        }
                    </table>
                </ScrollContainer>
            </div >
            <div className="flex justify-end"> {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}</div>
        </>
    )
}

export default Editions